import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom'
import './index.css';
//import './User/Setting/QualityReasonGroup/node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import './navbar.css';
import './reportActions.css';
// These were previously bundled once, in a fixed order, because every page's JS was
// eagerly loaded together. Now that routes are code-split (React.lazy), the dev server
// (style-loader) only injects a page's CSS when that page's chunk actually runs - so the
// order (and whether it's loaded at all) started depending on navigation history. Eagerly
// importing them here restores the original fixed load order in both dev and the build.
import 'react-toastify/dist/ReactToastify.css';
import './Common/table.css';
import './User/Setting/RelayTemplate/RelayTemplate.css';
import './User/Setting/ProcessParameterConfig/ProcessParameterConfig.css';
import './User/Setting/CustomerScheduleMaster/CustomerSchedule.css';
import './utill/common';
// The new UI: every rule in it is scoped under body.ln-ui, which applyUiMode() sets from
// the user's saved choice before the first render (classic by default). The generated
// colour swap for page stylesheets comes first, so the hand-written theme files win ties.
import './theme/pageOverrides.generated.css';
import './theme/newUi.css';
import './theme/settings.css';
import './theme/dataEntry.css';
import './theme/reports.css';
import './theme/dashboards.css';
import { applyUiMode } from './theme/uiMode';
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie9';
// import 'babel-polyfill';
// import 'core-js/stable';
// import "regenerator-runtime/runtime";
// import 'unorm';

import App from './App';

import * as serviceWorker from './serviceWorker';



applyUiMode();

ReactDOM.render(
<BrowserRouter>
<App  />
</BrowserRouter>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA


serviceWorker.register();
